module.exports = __webpack_public_path__ + "img/b9a8529.svg";